/**
 * LINE WORKS 通知（N仕事ルーム等）— 2026-07-12
 * daylist の車両ポジション（ピックアップ/ドロップオフのスタッフアサイン）等から
 * LINE WORKS のトークルームへテキストを送る。既定の送信先はサーバー側 .env の
 * LINEWORKS_NOTIFY_CHANNEL_ID（N仕事ルーム）。
 */
import { LINE_SYNC_KEY } from '../config/instances';

const NOTIFY_API_URL = (process.env.REACT_APP_LINEWORKS_NOTIFY_API_URL as string)
    || 'https://booking.trailernchu.co.jp/sys/lineworks/notify_api.php';
const API_KEY = LINE_SYNC_KEY;

/**
 * N仕事ルーム（既定）へテキストを送信する。失敗しても throw する（呼び出し側で握りつぶす想定）。
 * @param text 送信本文
 * @param channel 省略時はサーバー既定（N仕事）。'user:{userId}' で1:1も可
 */
export const sendLineWorksNotify = async (text: string, channel?: string): Promise<void> => {
    const res = await fetch(`${NOTIFY_API_URL}?action=send&api_key=${API_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text, ...(channel ? { channel } : {}) }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || 'LINE WORKS通知に失敗しました');
};
